import classNames from 'classnames';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useMutation } from '@tanstack/react-query';
import { Yup } from '@solid/shared/services/validation.service';
import * as authService from '../../services/auth.service';
import styles from '../common/Forms.module.scss';
import { Trans, useTranslation } from 'react-i18next';
const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Ungültige E-Mail-Adresse').required('Bitte geben Sie eine E-Mail-Adresse an'),
});

const ForgotPasswordForm: React.FC = () => {
  const {
    mutate: requestPasswordReset,
    error,
    isLoading,
    isSuccess,
  } = useMutation<void, Error, string>(authService.requestPasswordReset);
  const { t } = useTranslation();
  return (
    <Formik
      initialValues={{ email: '' }}
      onSubmit={values => requestPasswordReset(values.email)}
      validationSchema={ForgotPasswordSchema}>
      {({ isValid }) => (
        <Form>
          <div className='form-field'>
            <label htmlFor='forgot-password-email'>{t('pages.forgotPassword.form.email')}</label>
            <div className='control'>
              <Field type='email' name='email' id='forgot-password-email' autoComplete='email' required />
            </div>
            <ErrorMessage component='p' className='help is-danger' name='email' />
          </div>

          <div className='form-field'>
            {error && <div className='notification is-error'>{error.message}</div>}
            {isSuccess && (
              <div className='notification is-success'>
                <Trans i18nKey='pages.forgotPassword.form.successMessage' components={{ br: <br /> }} />
              </div>
            )}
          </div>

          <div className='form-field'>
            <button
              className={classNames('btn is-primary', styles.submitBtn, { 'is-loading': isLoading })}
              type='submit'
              disabled={isLoading || !isValid}>
              {t('pages.forgotPassword.form.button')}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ForgotPasswordForm;
